import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

function initialState () {
  return {
    token: null,
    user: null,
    ccInfo: null,
    nextPayment: null,
    referralProgram: null,
    planDetails: null,
    addOns: null,
    billingHistory: null,
    emailNotifications: null,
    declinedPayment: null,
    isMobileAppWebview: false,
    clients: null,
  }
}

export default new Vuex.Store({
  state: initialState,
  mutations: {
    reset (state) {
      // acquire initial state
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    setToken (state, token) {
      state.token = token

      if (token != null) {
        // todo: change to secure when on https
        // window.$cookies.set('token', token, '1d', '/', window.location.hostname,true)
        window.$cookies.set('token', token)
      } else {
        window.$cookies.remove('token')
      }
    },
    setUser (state, user) {
      state.user = user
    },
    setIsMobileAppPreview (state, isMobileAppPreview) {
      state.isMobileAppWebview = isMobileAppPreview;
    },
    setEmailNotifications (state, emailNotifications) {
      state.emailNotifications = emailNotifications
    },
    setCcInfo (state, cc) {
      state.ccInfo = cc
    },
    setNextPayment (state, nextPayment) {
      state.nextPayment = nextPayment
    },
    setReferralProgram (state, referralProgram) {
      state.referralProgram = referralProgram
    },
    setPlanDetails (state, planDetails) {
      state.planDetails = planDetails
    },
    setAddOns (state, addOns) {
      state.addOns = addOns
    },
    setBillingHistory (state, billingHistory) {
      state.billingHistory = billingHistory
    },
    setClients (state, clients) {
      state.clients = clients
    },
    setDeclinedPayment (state, declinedPayment) {
      state.declinedPayment = declinedPayment
    },
  },
  actions: {

  },
})
